import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const Compass = ({ rotation }) => {
  return (
    <div
      className="position-absolute bottom-0 end-0 p-3"
      style={{
        width: "50px",
        height: "50px",
        background: "rgba(0, 0, 0, 0.4)",
        borderRadius: "50%",
        border: "1px solid #fff",
        zIndex: 1000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      {/* Marcadores de direção */}
      <span
        style={{
          position: "absolute",
          top: "2px",
          color: "white",
          fontSize: "8px"
        }}
      >
        N
      </span>

      {/* Área rotacionável */}
      <div
        style={{
          width: "100%",
          height: "100%",
          position: "relative",
          transform: `rotate(${rotation}deg)`,
          transition: "transform 0.2s linear"
        }}
      >
        {/* Ícone do ponteiro ajustado para cima */}
        <i
          className="bi bi-cursor-fill"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%) rotate(315deg)", // Rotação para ajustar o ícone para cima
            fontSize: "16px",
            color: "red",
            animation: "spin 2s linear infinite"
          }}
        ></i>
      </div>
    </div>
  );
};

export default Compass;
